import { cn } from '@/src/infrastructure/lib/utils';
import { activeWindowHint } from '../lib/discount';
import type { CouponSummary, CouponStatus } from '../types';

const COLORS: Record<CouponStatus, string> = {
  DRAFT: 'bg-slate-500/15 text-slate-300 border-slate-500/30',
  ACTIVE: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  INACTIVE: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  EXPIRED: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30',
  EXHAUSTED: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30',
};

const HINT_TITLE = {
  ended: 'Past its end date — the expiry job marks it Expired within 5 minutes.',
  scheduled: 'Active, but not redeemable until its start date.',
};

export function CouponStatusBadge({ coupon }: { coupon: Pick<CouponSummary, 'status' | 'startAt' | 'endAt'> }) {
  const hint = activeWindowHint(coupon);
  return (
    <span
      title={hint ? HINT_TITLE[hint] : undefined}
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase font-bold tracking-widest whitespace-nowrap',
        COLORS[coupon.status],
      )}
    >
      {coupon.status}
      {hint && ` · ${hint}`}
    </span>
  );
}
